import type { ModalConfigIdType, ModalConfigStateType } from 'BreetConfig';
import type { IUseModalApi } from 'BreetHelpers';
import { closeModal, closeModals, openModal, selectModals, useAppDispatch, useAppSelector } from 'BreetRedux';
import { useCallback } from 'react';

export const useModalApi = (): IUseModalApi => {
	const dispatch = useAppDispatch();

	const modals = useAppSelector(selectModals);

	const handleModalClose = useCallback(
		(modalId: ModalConfigIdType, onClose?: () => void) => () => {
			dispatch(closeModal(modalId));
			onClose?.();
		},
		[dispatch]
	);

	const handleModalCloseAll = useCallback(() => {
		dispatch(closeModals());
	}, [dispatch]);

	const closeModalDirect = useCallback((modalId: ModalConfigIdType) => dispatch(closeModal(modalId)), [dispatch]);

	const openModalDirect = useCallback((payload: ModalConfigStateType) => dispatch(openModal(payload)), [dispatch]);

	const handleOpenModal = useCallback(
		(payload: ModalConfigStateType, onOpen?: () => void) => () => {
			dispatch(openModal(payload));
			onOpen?.();
		},
		[dispatch]
	);

	const getModalProps = (modalId: ModalConfigIdType) => modals.find((modal) => modal.id === modalId);

	const isOpenModal = (modalId: ModalConfigIdType) => !!modals.find((modal) => modal.id === modalId);

	return {
		handleModalClose,
		closeModalDirect,
		openModalDirect,
		handleOpenModal,
		isOpenModal,
		handleModalCloseAll,
		getModalProps,
	};
};
